export const SETTINGS = `
  query getAppSettings(
    $filter:  FilterAppSettingInput,
    $searchText : String,
    $orderBy:  AppSettingOrderInput,
    $skip: Int,
    $take: Int) {
    getAppSettings(
      filter: $filter
      searchText :$searchText
      orderBy: $orderBy
      skip: $skip
      take: $take

    ) {
    
      __typename
      ... on AppSetting {
        id
        screen_name
        setting_name
        setting_value
        description
        is_readonly
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const SETTING_KEY = `
query getAppSettingByKey(
  $input: SettingkeyInput!,
  ){
    getAppSettingByKey(
      input: $input
    ){
      __typename
      ... on AppSetting{
        setting_name
        setting_value
        description
      }
      ... on ResultError{
        status_code
        message
      }
    }
  }
  `;
